import axiosProvider from "../../utils/axios-provider/axios-provider";
import getIsCoppa from "../coppa";
import { decode } from "html-entities";
// Actions
export const FETCH_PERSONAL_USER_REQUEST =
  "personaluser/FETCH_PERSONAL_USER_REQUEST";
export const FETCH_PERSONAL_USER_SUCCESS =
  "personaluser/FETCH_PERSONAL_USER_SUCCESS";
export const FETCH_PERSONAL_USER_FAILURE =
  "personaluser/FETCH_PERSONAL_USER_FAILURE";
export const SAVE_PERSONAL_USER_REQUEST =
  "personaluser/SAVE_PERSONAL_USER_REQUEST";
export const SAVE_PERSONAL_USER_SUCCESS =
  "personaluser/SAVE_PERSONAL_USER_SUCCESS";
export const SAVE_PERSONAL_USER_FAILURE =
  "personaluser/SAVE_PERSONAL_USER_FAILURE";

// Reducer
export const initialState = {
  loading: true,
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PERSONAL_USER_REQUEST:
      return { ...state, error: null, loading: true };
    case SAVE_PERSONAL_USER_REQUEST:
      return { ...state, saveError: null, loading: true };
    case FETCH_PERSONAL_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ...action.payload
      };
    case SAVE_PERSONAL_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        saveError: null,
        ...action.payload
      };
    case FETCH_PERSONAL_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SAVE_PERSONAL_USER_FAILURE:
      return {
        ...state,
        loading: false,
        saveError: action.payload
      };
    default:
      return state;
  }
}

// Action Creators
export const fetchPersonalUserRequest = () => ({
  type: FETCH_PERSONAL_USER_REQUEST
});

export const fetchPersonalUserSucess = data => ({
  type: FETCH_PERSONAL_USER_SUCCESS,
  payload: data
});

export const fetchPersonalUserFailure = error => ({
  type: FETCH_PERSONAL_USER_FAILURE,
  payload: error
});

export const fetchPersonalUser = (baseUrl = "/api") => async dispatch => {
  dispatch(fetchPersonalUserRequest());
  try {
    const response = await axiosProvider
      .getInstance()
      .get(`${baseUrl}/personaluser`);
    dispatch(fetchPersonalUserSucess(response.data));
  } catch (error) {
    dispatch(fetchPersonalUserFailure(error));
  }
};

export const savePersonalUserRequest = () => ({
  type: SAVE_PERSONAL_USER_REQUEST
});

export const savePersonalUserSuccess = payload => ({
  type: SAVE_PERSONAL_USER_SUCCESS,
  payload
});

export const savePersonalUserFailure = error => ({
  type: SAVE_PERSONAL_USER_FAILURE,
  payload: error
});

/// Selectors
export const getGravatarUrl = state => state.personalUser.gravatarUrl || null;

export const getEmail = state => state.personalUser.primaryEmail || null;
export const getUsername = state => state.personalUser.userName || null;

export const getAccountDisplayName = state => {
  return getIsCoppa(state)
    ? state.personalUser.userName
    : state.personalUser.primaryEmail;
};

export const getAffiliations = state => state.personalUser.affiliations || [];
export const getRoles = state => state.personalUser.adminRoles || [];

export const getUserInfo = state => {
  const {
    puaId,
    primaryEmail,
    givenName,
    familyName,
    social,
    userName,
    coppa
  } = state.personalUser;
  if (puaId) {
    return getIsCoppa(state)
      ? {
          givenName: decode(givenName),
          social,
          userName: decode(userName),
          coppa,
          puaId
        }
      : {
          primaryEmail: decode(primaryEmail),
          givenName: decode(givenName),
          familyName: decode(familyName),
          social,
          puaId
        };
  } else {
    return null;
  }
};

export const getIsPersonalUserCoppa = state =>
  Boolean(state.personalUser.coppa);
export const getSecretQuestionCode = state =>
  state.personalUser.secretQuestionCode || null;
export const getUserInfoError = state => state.personalUser.error;

export const getUserInfoLoading = state => state.personalUser.loading;
export const saveUserInfoError = state => state.personalUser.saveError;

export const getIsSso = state => {
  const { social, accountType = "" } = state.personalUser;
  const isAccountTypeSso = accountType.toLowerCase() === "sso";

  return Boolean(isAccountTypeSso || social);
};
